import React from "react";
import { Card, Text, Table, TableBody, TableRow, TableCell } from "@jsq/ds/core";
import { cardTitle, tableRow, tableCell } from "./styles_vanilla.css";
import { ClientDetailsCardProps } from "./types";

export const ClientDetailsCard: React.FC<ClientDetailsCardProps> = ({ clientName }) => {
  return (
    <Card padding="lg">
      <Text className={cardTitle} variant="secondary-md">
        CLIENT DETAILS
      </Text>
      <Table condensed>
        <TableBody>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text variant="secondary-md">Client</Text>
            </TableCell>
            <TableCell>
              <Text variant="regular-md">{clientName}</Text>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};
